import withAemIntegration from "../../withAemIntegration";
import {
  ResponsiveGrid,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import ComponentWrapper from "../component-wrapper";
import styled from "styled-components";

const ContainerEditConfig = {
  emptyLabel: "Container Module",
  isEmpty: (props) => !props?.children?.length,
};

const ClearFix = styled.div`
  &:before,
  &:after {
    content: "";
    display: table;
  }
  &:after {
    clear: both;
  }
`;

export class Container extends ResponsiveGrid {
  render() {
    return (
      <ClearFix {...this.containerProps}>
        <ComponentWrapper>{super.childComponents}</ComponentWrapper>
        {super.placeholderComponent}
      </ClearFix>
    );
  }
}

const ContainerComponent = withComponentMappingContext(Container);
ContainerComponent.displayName = "Container";

export default withAemIntegration(["lexus/components/container",
  "lexus/components/content/container",
  "lexus/components/content/flex-grid/2-column-template",
  "lexus/components/content/flex-grid/3-column-template",
  "lexus/components/content/flex-grid/4-column-template"])(
  ContainerComponent,
  ContainerEditConfig
);
